/* fdd-hero-price.js — shows each product's price on the top scrolling hero banner.
   Reversible: remove this asset + its <script> include in layout/theme.liquid.
   Reads live price from /products/{handle}.js so it always matches the store. */
(function () {
  'use strict';
  var SECTION = '.hdt-infinite-loop-slider-section';
  var CACHE = {}; // handle -> price(cents) | 'loading'
  // Extra product to add into the hero banner marquee (50 Red Rose Bouquet)
  var EXTRA_IMG = 'https://cdn.shopify.com/s/files/1/0898/0971/5563/files/F56007D5-6CA3-4D7A-86E5-AF107C2092DC.png?v=1785070624&width=600';
  var EXTRA_HREF = '/products/50-red-rose-bouquet';

  function formatMoney(cents) {
    var n = (cents / 100).toFixed(2).split('.');
    n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'Dhs. ' + n.join('.');
  }

  function handleFromHref(href) {
    if (!href) return null;
    var m = href.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function addBadge(col, text) {
    if (!col || col.querySelector('.fdd-hero-price')) return;
    var d = document.createElement('div');
    d.className = 'fdd-hero-price';
    d.textContent = text;
    col.appendChild(d);
  }

  function applyHandle(handle, price) {
    if (!(price > 0)) return;
    var links = document.querySelectorAll(SECTION + ' a[href*="/products/' + handle + '"]');
    for (var i = 0; i < links.length; i++) {
      var col = links[i].closest('.hdt-col');
      if (col) addBadge(col, formatMoney(price));
    }
  }

  function process() {
    var cols = document.querySelectorAll(SECTION + ' .hdt-col');
    for (var i = 0; i < cols.length; i++) {
      var col = cols[i];
      if (col.querySelector('.fdd-hero-price')) continue;
      var a = col.querySelector('a[href*="/products/"]');
      if (!a) continue;
      var handle = handleFromHref(a.getAttribute('href'));
      if (!handle) continue;
      var cached = CACHE[handle];
      if (cached === 'loading') continue;
      if (typeof cached === 'number') { applyHandle(handle, cached); continue; }
      CACHE[handle] = 'loading';
      (function (h) {
        fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            var price = (p && typeof p.price === 'number') ? p.price : 0;
            CACHE[h] = price;
            applyHandle(h, price);
          })
          .catch(function () { CACHE[h] = 0; });
      })(handle);
    }
  }

  function injectExtra() {
    var rows = document.querySelectorAll(SECTION + ' .hdt-marquee-item .hdt-row-flex');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (row.querySelector('[data-fdd-50rose]')) continue;
      var first = row.querySelector('.hdt-col');
      if (!first) continue;
      var clone = first.cloneNode(true);
      clone.setAttribute('data-fdd-50rose', '1');
      var pb = clone.querySelector('.fdd-hero-price'); if (pb) pb.remove();
      var pic = clone.querySelector('picture');
      if (pic) { var srcs = pic.querySelectorAll('source'); for (var s = 0; s < srcs.length; s++) srcs[s].remove(); }
      var img = clone.querySelector('img');
      if (img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = EXTRA_IMG; img.setAttribute('loading', 'lazy'); img.alt = '50 Red Rose Bouquet'; }
      var a = clone.querySelector('a.hdt-full-width-link');
      if (a) { a.setAttribute('href', EXTRA_HREF); a.removeAttribute('disabled'); a.removeAttribute('role'); }
      row.appendChild(clone);
    }
  }

  function injectCSS() {
    if (document.getElementById('fdd-hero-price-css')) return;
    var s = document.createElement('style');
    s.id = 'fdd-hero-price-css';
    s.textContent =
      SECTION + ' .hdt-col{position:relative}' +
      '.fdd-hero-price{position:absolute!important;left:50%!important;bottom:14px!important;transform:translateX(-50%)!important;z-index:4!important;' +
      'display:inline-block!important;pointer-events:none;background:rgba(38,35,32,.9);color:#f7efe0!important;font-weight:600!important;font-size:14px!important;' +
      'line-height:1.5!important;letter-spacing:.02em;padding:6px 14px!important;border-radius:999px!important;white-space:nowrap!important;' +
      'box-shadow:0 2px 12px rgba(0,0,0,.28)}' +
      '@media (max-width:767px){.fdd-hero-price{font-size:12px!important;padding:5px 11px!important;bottom:10px!important}}' +
      '.hdt-product-btns{display:none!important}' +
      '.hdt-card-product__media-wrapp{aspect-ratio:1/1!important;padding-bottom:0!important;height:auto!important;overflow:hidden!important}' +
      '.hdt-card-product__media-wrapp img,.hdt-card-product__media img,.hdt-card-product__media .hdt-media img{width:100%!important;height:100%!important;object-fit:cover!important}';
    document.head.appendChild(s);
  }

  function tick() { injectExtra(); process(); }

  function init() {
    injectCSS();
    if (!document.querySelector(SECTION)) return;
    tick();
    // marquee clones can appear after load — retry briefly + observe
    var tries = 0;
    var iv = setInterval(function () { tick(); if (++tries >= 15) clearInterval(iv); }, 800);
    var host = document.querySelector(SECTION);
    if (host && window.MutationObserver) {
      new MutationObserver(function () { tick(); }).observe(host, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
